import classNames from 'classnames';
import * as classes from './Body.css';
// import "./customBody.scss";
import {AriaRole, ComponentProps, ReactNode} from 'react';
import BaseTypography from '../BaseTypography';
// import { renderToString } from 'react-dom/server';
// import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Filter } from '@/types/app.type';
import ContentfulRichText from '@/server/ContentfulRichText';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
// import { renderToString } from 'react-dom/server';

export interface BodyProps {
  'data-test-id'?: string;
  id?: string;
  /**
   * Define the content of the Body.
   * @type string
   * @required
   */
  children?: ReactNode;
  /**
   * Define the content of the Body.
   * @type string
   * @required
   */
  description?: any;
  /**
   * Define the color of the Body.
   * @type ComponentProps<typeof BaseTypography>['color'];
   * @optional
   */
  color?: ComponentProps<typeof BaseTypography>['color'];
  /**
   * Define the custom className.
   * @type string
   * @optional
   */
  className?: string;
  /**
   * Define the font size of the Body.
   * @type 'xxs' | "xs" | "s" | "m" | "l" | "xl"
   * @required
   */
  size: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl';
  /**
   * Define the font style of the Body.
   * @type string
   * @optional
   */
  fontStyle?: string;
  /**
   * Define the component type.
   * @type "span" | "p" | "label" | "h4" | "h5"
   * @optional
   */
  component?: keyof Pick<React.JSX.IntrinsicElements, 'span' | 'p' | 'label' | 'h4' | 'h5'>;
  /**
   * Define the text role.
   * @type  "article" | "caption" | "listitem" | "menuitem" | "menuitemcheckbox" | "menuitemradio" | "option" | "link" | "none"
   * @optional
   */
  role?: Filter<
    AriaRole,
    'article' | 'caption' | 'listitem' | 'menuitem' | 'menuitemcheckbox' | 'menuitemradio' | 'option' | 'link' | 'none'
  >;
  /**
   * Define the label for if associated with an input.
   * @type string
   * @optional
   */
  htmlFor?: string;
  /**
   * Define the title of the Body.
   * @type string
   * @optional
   */
  title?: string;
  /**
   * Hide Body Component.
   * @type string
   * @optional
   */
  hide?: boolean;
  /**
   * Define the horizontal alignment of the Body.
   * @type "left" | "center" | "right"
   * @optional
   */
  hAlignContent?: 'left' | 'center' | 'right';
  /**
   * Define the Body weightiness.
   * @type boolean
   * @optional
   * @default false
   */
  bold?: boolean;
  /**
   * Enable animation triggered whe the element is visible.
   * @type boolean
   * @optional
   */
  animated?: boolean;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animation?: string;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animationType?: string;
  linksInNewTab?: boolean;

}

export function Body(props: BodyProps) {
  return (
    <>
    {/* {documentToReactComponents(props.description)} */}
      {!props?.hide && <BaseTypography
        data-test-id={props['data-test-id']}
        title={props.title}
        role={props.role ?? 'none'}
        // component={["span", "p"].includes(props.component || "") ? props.component || "span" : 'span'}
        component={props.component ?? 'span'}
        htmlFor={props.htmlFor}
        hAlignContent={props.hAlignContent}
        color={props.color}
        style={{
          fontFamily: !props?.fontStyle ? 'notoIkea, sans-serif' : props?.fontStyle === "default" ? 'notoIkea, sans-serif' : `${props?.fontStyle}, sans-serif`,
        }}
        className={classNames(
          "custom-body",
          classes.variant(props?.bold)[props.size], 
          props.className
        )}
        animated={props.animated ?? false}
        animation={(props.animation || props.animationType) ?? ''}
        id={props?.id || ""}
      >
          {/* {props.description ? 
            // renderToString(documentToReactComponents(props.description)) 
            documentToReactComponents(props.description)
          : props.children} */}
        {
          props?.description ? (
            typeof props?.description === "string" ?
              props?.description :
              <ContentfulRichText document={props?.description} target={props?.linksInNewTab? "_blank" : "_self"}/>

          ) :
            (
              typeof props?.children === "string" ?
                props?.children :
                <ContentfulRichText document={props?.description || props?.children} target={props?.linksInNewTab? "_blank" : "_self"}/>
            )
        }
          
      </BaseTypography>}
    </>
  );
}


// Tailwind Font approach -- (avoid)
        // `font-${props?.fontStyle === "body" ? classes.base : props?.fontStyle}`, 
        // {
        //   [`font-${classes.base}`] : props?.fontStyle === "body",
        //   [`font-${props?.fontStyle}`]: props?.fontStyle !== "body"
        // }, 
        // props?.fontStyle ? `font-${props?.fontStyle}` : `font-${classes.base}`,
        // props?.fontStyle ? `font-${props?.fontStyle}` : `font-body`,